/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocks_Market_Indicators_Sp500_Etf_LabelInputs */

const en_stocks_market_indicators_sp500_etf_label = /** @type {(inputs: Stocks_Market_Indicators_Sp500_Etf_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S&P 500 ETF`)
};

const de_stocks_market_indicators_sp500_etf_label = /** @type {(inputs: Stocks_Market_Indicators_Sp500_Etf_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S&P 500 ETF`)
};

const pt_br2_stocks_market_indicators_sp500_etf_label = /** @type {(inputs: Stocks_Market_Indicators_Sp500_Etf_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S&P 500 ETF`)
};

const tr_stocks_market_indicators_sp500_etf_label = /** @type {(inputs: Stocks_Market_Indicators_Sp500_Etf_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S&P 500 ETF`)
};

const zh_cn2_stocks_market_indicators_sp500_etf_label = /** @type {(inputs: Stocks_Market_Indicators_Sp500_Etf_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标普 500 ETF`)
};

const zh_hk2_stocks_market_indicators_sp500_etf_label = /** @type {(inputs: Stocks_Market_Indicators_Sp500_Etf_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標普 500 ETF`)
};

const ko_kr2_stocks_market_indicators_sp500_etf_label = /** @type {(inputs: Stocks_Market_Indicators_Sp500_Etf_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S&P 500 ETF`)
};

const ru_ru2_stocks_market_indicators_sp500_etf_label = /** @type {(inputs: Stocks_Market_Indicators_Sp500_Etf_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETF на S&P 500`)
};

const es_419_stocks_market_indicators_sp500_etf_label = /** @type {(inputs: Stocks_Market_Indicators_Sp500_Etf_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETF S&P 500`)
};

/**
* | output |
* | --- |
* | "S&P 500 ETF" |
*
* @param {Stocks_Market_Indicators_Sp500_Etf_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const stocks_market_indicators_sp500_etf_label = /** @type {((inputs?: Stocks_Market_Indicators_Sp500_Etf_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocks_Market_Indicators_Sp500_Etf_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stocks_market_indicators_sp500_etf_label(inputs)
	if (locale === "de") return de_stocks_market_indicators_sp500_etf_label(inputs)
	if (locale === "pt-BR") return pt_br2_stocks_market_indicators_sp500_etf_label(inputs)
	if (locale === "tr") return tr_stocks_market_indicators_sp500_etf_label(inputs)
	if (locale === "zh-CN") return zh_cn2_stocks_market_indicators_sp500_etf_label(inputs)
	if (locale === "zh-HK") return zh_hk2_stocks_market_indicators_sp500_etf_label(inputs)
	if (locale === "ko-KR") return ko_kr2_stocks_market_indicators_sp500_etf_label(inputs)
	if (locale === "ru-RU") return ru_ru2_stocks_market_indicators_sp500_etf_label(inputs)
	return es_419_stocks_market_indicators_sp500_etf_label(inputs)
});